import * as actionTypes from "./actionTypes";
import * as types from "./types";


// DELETE Subscription Details
const initDeleteSubscriptionState: types.IDeleteSubscriptionState = {
    pending: false,
    success: null,
    error: null,
  };
  
  export const DeleteSubscriptionReducer = (state = initDeleteSubscriptionState, action: types.DeleteSubscriptionActions) => {
    switch (action.type) {
        case actionTypes.DELETE_SUBSCRIPTION_REQUEST:
            return {
                ...state,
                success: null,
                pending: true,
            };
        case actionTypes.DELETE_SUBSCRIPTION_SUCCESS:
            return {
                ...state,
                pending: false,
                success: action.success,
                error: null,
            };
        case actionTypes.DELETE_SUBSCRIPTION_FAILURE:
            return {
                ...state,
                pending: false,
                success: null,
                error: action.payload.error,
            };
            case actionTypes.DELETE_SUBSCRIPTION_RESET:
              return {
                  ...state,
                  pending: false,
                  success: null,
                  error: null,
              };
        default:
            return {
                ...state,
            };
    }
  };


  // POST Subscription

const initialStateSubscription: types.IPostSubscriptionState = {
    pending: false,
    subscription: null,
    error: null,
  };
  
  export const PostSubscriptionReducer = (
    state = initialStateSubscription,
    action: types.PostSubscriptionActions
  ) => {
    switch (action.type) {
      case actionTypes.POST_SUBSCRIPTION_REQUEST:
        return {
          ...state,
          pending: true,
        };
      case actionTypes.POST_SUBSCRIPTION_SUCCESS:
        return {
          ...state,
          pending: false,
          subscription: action.payload.subscription,
          error: null,
        };
        case actionTypes.POST_SUBSCRIPTION_RESET:
          return {
            ...state,
            pending: false,
            subscription: null,
            error: null,
          };
      case actionTypes.POST_SUBSCRIPTION_FAILURE:
        return {
          ...state,
          pending: false,
          subscription: null,
          error: action.payload.error,
        };
      default:
        return {
          ...state,
        };
    }
  };

    // POST Extractor Subscription

const initialStateExtractorSubscription: types.IPostExtractorSubscriptionState = {
  pending: false,
  subscription: null,
  error: null,
};

export const PostExtractorSubscriptionReducer = (
  state = initialStateExtractorSubscription,
  action: types.PostExtractorSubscriptionActions
) => {
  switch (action.type) {
    case actionTypes.POST_EXTRACTOR_SUBSCRIPTION_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case actionTypes.POST_EXTRACTOR_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        pending: false,
        subscription: action.payload.subscription,
        error: null,
      };
      case actionTypes.POST_EXTRACTOR_SUBSCRIPTION_RESET:
        return {
          ...state,
          pending: false,
          subscription: null,
          error: null,
        };
    case actionTypes.POST_EXTRACTOR_SUBSCRIPTION_FAILURE:
      return {
        ...state,
        pending: false,
        subscription: null,
        error: action.payload.error,
      };
    default:
      return {
        ...state,
      };
  }
};

  //Get Subscription List

const initSubscriptionState: types.FetchSubscriptionState = {
  pending: false,
  subscription: {} as types.ISubscriptionDetails[],
  error: null,
};

export const SubscriptionDetailsReducer = (
  state = initSubscriptionState,
  action: types.SubscriptionActions
) => {
  switch (action.type) {
    case actionTypes.FETCH_SUBSCRIPTION_LIST_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case actionTypes.FETCH_SUBSCRIPTION_LIST_SUCCESS:
      return {
        ...state,
        pending: false,
        subscription: action.payload.subscription,
        error: null,
      };
    case actionTypes.FETCH_SUBSCRIPTION_LIST_FAILURE:
      return {
        ...state,
        pending: false,
        subscription: {} as types.ISubscriptionDetails[],
        error: action.payload.error,
      };
      case actionTypes.FETCH_SUBSCRIPTION_LIST_RESET:
        return {
          ...state,
          pending: false,
          subscription: {} as types.ISubscriptionDetails[],
          error: null,
        };
    default:
      return {
        ...state,
      };
  }
};
